"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unmountApp = void 0;
const unmountApp = async (appName) => {
    // First, unmount any components from the app if they exist
    if (typeof window !== 'undefined' && window[appName]) {
        // Preserve the init and get functions
        const initFunction = window[appName].init;
        const getFunction = window[appName].get;
        if (window[appName]) {
            if (typeof window[appName].unmount === 'function') {
                window[appName].unmount();
            }
            // Clear all properties except init and get functions
            // const appObject = window[appName];
            // const keysToDelete = Object.keys(appObject).filter(key => key !== 'init' && key !== 'get');
            // keysToDelete.forEach(key => delete appObject[key]);
            // // Ensure init and get functions are preserved if they existed
            // if (initFunction && !appObject.init) appObject.init = initFunction;
            // if (getFunction && !appObject.get) appObject.get = getFunction;
        }
    }
    return true;
};
exports.unmountApp = unmountApp;
//# sourceMappingURL=unmount.js.map